import * as Icons from "lucide-react";
import { Reveal, RevealStagger, revealItem } from "@/components/Reveal";
import { motion } from "framer-motion";
import { WHY_INVEST } from "@/constants/content";

export const WhyInvest = () => (
  <section id="why-invest" className="cp-section cp-section--cream" data-testid="why-invest-section">
    <div className="cp-container">
      <Reveal className="cp-section-head">
        <span className="cp-eyebrow">Why Invest</span>
        <h2 className="cp-h2">Why Kharkhoda, Why Now</h2>
      </Reveal>

      <RevealStagger className="cp-invest-grid" stagger={0.08}>
        {WHY_INVEST.map((w) => {
          const Icon = Icons[w.icon] || Icons.Sparkles;
          return (
            <motion.div key={w.title} variants={revealItem} className="cp-invest-card" data-testid={`why-invest-card-${w.icon.toLowerCase()}`}>
              <div className="cp-invest-icon">
                <Icon size={22} strokeWidth={1.6} />
              </div>
              <h3>{w.title}</h3>
              <p>{w.desc}</p>
              {w.href && (
                <a href={w.href} target="_blank" rel="noreferrer" className="cp-invest-link">
                  {w.linkLabel || "Learn more"}
                </a>
              )}
            </motion.div>
          );
        })}
      </RevealStagger>
    </div>
  </section>
);
